import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import default_profile_image from "../../../assets/expert-images/profile.jpg";
import NoExpertFound from "../../../components/NoExpertFound";
import { formatDesignation } from "../../../utils/formatDesignation";

const AllGenericProfilePage = () => {
  const { id } = useParams();
  const expert_id = atob(id); // decode base64
  const { experts_profile } = useSelector((state) => state.expertData);

  const [expertDetails, setExpertDetails] = useState([]);

  useEffect(() => {
    if (experts_profile && experts_profile.data?.length) {
      setExpertDetails(experts_profile.data);
    }
  }, [experts_profile]);

  // Filter expert by user_id
  const expert = expertDetails.find((e) => e.user_id === expert_id) || {};

  // Fallback for image
  const profileImage = expert?.profile_image?.[0]?.url || default_profile_image;

  return (
    <div className="pt-28 lg:pt-32 py-10 px-[5vw] sm:px-[10vw] xl:px-[15vw]">
      {Object.keys(expert).length === 0 ? (
        <NoExpertFound />
      ) : (
        <div className="flex flex-col lg:flex-row p-2 bg-gray rounded-lg overflow-hidden">
          {/* Image & Name Section */}
          <div className="lg:w-1/2 w-full bg-white flex flex-col justify-center items-center">
            <img
              src={profileImage}
              alt={expert.name}
              className="w-auto max-w-[320px] h-[50vh]"
            />
            <div className="py-[26px] text-center bg-ash-500 w-full h-auto">
              <h2 className="text-xl font-bold text-white uppercase">
                {expert.name}
              </h2>
              <p className="text-sm text-white italic capitalize">
                {formatDesignation(expert.designation) || "Property Expert"}
              </p>
            </div>
          </div>

          {/* Content & Buttons Section */}
          <div className="lg:w-1/2 w-full flex flex-col justify-between bg-gray">
            <div className="h-full">
              <div className="bg-yellow text-center py-3">
                <p className="text-base font-bold leading-relaxed uppercase">About&nbsp;{expert.name}</p>
              </div>
              <div>
                <p className="py-2 px-3 text-base leading-relaxed">
                  {expert?.about || "No about provided!"}
                </p>
              </div>
            </div>

            <div className="py-4 px-2 bg-yellow lg:gap-3 flex flex-col items-center justify-center">
              <div className="text-black text-sm mb-4 lg:mb-0 capitalize">
                Want to connect with {expert.name}?
              </div>
              <div className="flex gap-3">
                <a href={`tel:${expert.company_phone}`}>
                  <button className="bg-white px-8 py-2 rounded outline-none hover:outline hover:outline-ash-200 text-sm font-medium">
                    Contact Me
                  </button>
                </a>
                <a href={`mailto:${expert.email}`}>
                  <button className="bg-white px-10 py-2 rounded outline-none hover:outline hover:outline-ash-200 text-sm font-medium">
                    Email Me
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllGenericProfilePage;
